
import UserProfileChecker from '../Auth/UserProfileChecker'

const EmailVerification = () => {
    return (
        <div style={{
            backgroundColor: "#f4f4f4",
            padding: "2rem",
            borderRadius: "5px",
            margin: "1rem 0"
        }}>
            <h4 style={{ marginTop: 0 }}>
                Please verify your email address to access all features.
            </h4>

            <p>
                Already verified your email? Sometimes it takes a few minutes for the status to update.
            </p>

            <UserProfileChecker />
        </div>
    )
}

export default EmailVerification;